import { statusBadge } from './status-badge';
import { getPersonName } from '../state';

export function approvalCard(a: { id: string; type: string; subject: string; status: string; requested_by: string; amount: number | null }): string {
  const amt = a.amount ? ` - $${a.amount.toFixed(2)}` : '';
  return `
    <div class="approval-card" data-approval-id="${a.id}">
      <div class="approval-info">
        <div class="approval-subject">${escHtml(a.subject)}${amt}</div>
        <div class="approval-meta">${escHtml(a.type)} by ${escHtml(getPersonName(a.requested_by))}</div>
      </div>
      ${statusBadge(a.status)}
      ${a.status === 'pending' ? `
        <div class="approval-actions">
          <button class="btn btn-sm btn-primary" data-action="approve" data-id="${a.id}">Approve</button>
          <button class="btn btn-sm btn-danger" data-action="deny" data-id="${a.id}">Deny</button>
        </div>
      ` : ''}
    </div>
  `;
}

function escHtml(str: string): string {
  const el = document.createElement('div');
  el.textContent = str;
  return el.innerHTML;
}
